import { Component, Inject, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../_services/api/auth.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomValidators } from '../../_validators/custom.validators';

@Component({
  selector: 'app-resend-verification',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './resend-verification.component.html',
  styleUrls: ['./resend-verification.component.scss']
})
export class ResendVerificationComponent implements OnInit {
  private authService = inject(AuthService);
  private fb = inject(FormBuilder);
  private router = inject(Router);

  resendForm!: FormGroup;
  isLoading: boolean = false;
  isSuccess: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object){
    this.initializeForm();
  }

  ngOnInit(): void {
  }

  private initializeForm(): void {
    this.resendForm = this.fb.group({
      email: ['', [Validators.required, CustomValidators.email]]
    });
  }

  onSubmit(): void {
    if (this.resendForm.invalid) {
      this.markFormGroupTouched();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.successMessage = '';
    this.isSuccess = false;

    const email = this.resendForm.get('email')?.value;

    this.authService.resendVerification(email).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.isSuccess = true;
        this.successMessage = response.message || 'Lien de vérification envoyé avec succès! Vérifiez votre boîte email.';
        this.resendForm.reset();
        
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 5000);
      },
      error: (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.isSuccess = false;
        
        if (error.status === 404) {
          this.errorMessage = 'Aucun compte trouvé avec cet email.';
        } else if (error.status === 409) {
          this.errorMessage = 'Cette adresse email est déjà vérifiée.';
        } else if (error.status === 429) {
          this.errorMessage = 'Trop de tentatives. Veuillez patienter avant de réessayer.';
        } else {
          this.errorMessage = 'Une erreur est survenue. Veuillez réessayer plus tard.';
        }
      }
    });
  }

  private markFormGroupTouched(): void {
    Object.keys(this.resendForm.controls).forEach(key => {
      const control = this.resendForm.get(key);
      control?.markAsTouched();
    });
  }

  getFieldError(fieldName: string): string {
    const control = this.resendForm.get(fieldName);
    if (control && control.errors && control.touched) {
      const errors = control.errors;
      if (errors['required']) return 'Ce champ est requis';
      if (errors['email']) return errors['email'];
    }
    return '';
  }

  hasError(fieldName: string): boolean {
    const control = this.resendForm.get(fieldName);
    return !!(control && control.invalid && control.touched);
  }

  get f() { return this.resendForm.controls; }
}